module.exports = __webpack_public_path__ + "img/gong_kao.80278202.png";